module.exports = __webpack_public_path__ + "img/top_smoke.1f76d473.png";